const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const dislayPrice = (x) => {
  return `${numberWithCommas(x)} đ`;
};

export { numberWithCommas, dislayPrice };
